module.exports = __webpack_public_path__ + "media/dorobek/assets/images/pbn-fb3185eb51017ae12ac7889df148e1ba.svg";